import React, { useState } from "react";
import { FaEdit, FaTrash, FaSearch, FaInfoCircle } from "react-icons/fa"; // 🔥 Agregar FaInfoCircle
import Pagination from "../Pagination";
import ConfirmModal from "../Modals/ConfirmModal";

const AsignaturasTable = ({ asignaturas, onEdit, onDelete }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const itemsPerPage = 10;

  // Filtrar asignaturas
  const asignaturasFiltradas = asignaturas.filter((asig) =>
    asig.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Paginación
  const totalPages = Math.ceil(asignaturasFiltradas.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const asignaturasPaginadas = asignaturasFiltradas.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleDelete = () => {
    if (deleteId) {
      onDelete(deleteId);
      setDeleteId(null);
    }
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-md">
      <h3 className="text-xl font-semibold mb-4">Lista de Asignaturas</h3>

      {/* Buscador */}
      <div className="mb-6 relative">
        <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder="Buscar asignatura..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="w-full pl-12 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      {asignaturasFiltradas.length === 0 ? (
        <p className="text-center text-gray-500 py-8">
          No se encontraron asignaturas
        </p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-4 py-3 text-left">Asignatura</th>
                  <th className="border px-4 py-3 text-center">
                    Salones Asignados
                  </th>
                  <th className="border px-4 py-3 text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {asignaturasPaginadas.map((asignatura) => (
                  <tr key={asignatura.asignatura_id} className="hover:bg-gray-50">
                    <td className="border px-4 py-3">
                      {/* 🔥 NUEVO: Nombre + Descripción en tooltip */}
                      <div className="flex items-center gap-2">
                        <span className="font-semibold">{asignatura.nombre}</span>
                        {asignatura.descripcion && (
                          <div className="relative group">
                            <FaInfoCircle className="text-blue-500 cursor-help" size={16} />
                            <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray text-white text-xs rounded-lg px-3 py-2 w-64 z-10 shadow-lg">
                               Dimension {asignatura.descripcion}
                              <div className="absolute top-full left-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="border px-4 py-3 text-center">
                      <span className="inline-flex items-center justify-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold text-sm">
                        {asignatura.salones_asignados.length} salones
                      </span>
                    </td>
                    <td className="border px-4 py-3">
                      <div className="flex justify-center gap-3">
                        <button
                          onClick={() => onEdit(asignatura)}
                          className="text-blue-600 hover:text-blue-800 transition-colors"
                          title="Editar"
                        >
                          <FaEdit size={18} />
                        </button>
                        <button
                          onClick={() => setDeleteId(asignatura.asignatura_id)}
                          className="text-red-600 hover:text-red-800 transition-colors"
                          title="Eliminar"
                        >
                          <FaTrash size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="mt-6">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </>
      )}

      {/* Modal de confirmación de eliminación */}
      {deleteId && (
        <ConfirmModal
          message="¿Estás seguro de eliminar esta asignatura? Esta acción no se puede deshacer."
          onConfirm={handleDelete}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </div>
  );
};

export default AsignaturasTable;